<template>
  <div class="bg-white dark:bg-gray-900 shadow-md rounded-lg p-6 w-full lg:w-1/3 flex flex-col">
    <div class="flex items-center gap-4">
      <div 
        class="w-16 h-16 bg-red-500 dark:bg-red-700 text-white flex items-center justify-center text-2xl font-bold rounded-full"
      >
        {{ getInitials }}
      </div>
      <div>
        <h2 class="text-xl text-gray-700 dark:text-gray-300">{{ $t('ui.welcome_back') }},</h2>
        <p class="text-lg font-bold text-gray-900 dark:text-gray-100">{{ user.name }}!</p>
      </div>
    </div>
    <hr class="my-4 border-gray-300 dark:border-gray-700">
  </div>
</template>

<script>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

export default {
  setup() {
    const user = computed(() => usePage().props.auth.user);
    const getInitials = computed(() => {
      if (!user.value || !user.value.name) return 'U';
      const nameParts = user.value.name.split(' ');
      if (nameParts.length === 1) {
        return nameParts[0].charAt(0).toUpperCase();
      } else {
        return (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase();
      }
    });
    return {
      user,
      getInitials
    };
  }
}
</script>